<template>
    <div v-if="isNoWindow" class="content">
        {{text}}
    </div>
</template>
<style>
.content {
    color: red;
    width: 300px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    margin: 0 auto;
}
</style>
<script>
export default {
    name : "noWindow",
    mounted : function(){
        this.$store.registerModule(['system','noWindow'],{
            state : {
                $ : this
            }
        });
    },
    data : function(){
        var data = {
            isNoWindow : false,
            text : "未指定窗口,且无默认窗口"
        }
        return data;
    },
    methods : {
        show : function(isShow,text){
            if(text){
                this.text = text;
            }
            var TextStr = this.$store.state.system.$.getResource("未指定窗口,且无默认窗口");
            this.text = TextStr ? TextStr : "未指定窗口,且无默认窗口";
            this.isNoWindow = isShow ? true : false;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/noWindow.vue